import React, { useEffect, useState } from "react";
import { IoSettingsOutline } from "react-icons/io5";
import RightDrawer from "../../component/RightDrawer";
import AccrodianBox from "../../component/AccrodianBox";
import InputField from "../../component/InputField";
import ButtonCompo from "../../component/ButtonCompo";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import { Checkbox, LinearProgress } from "@mui/material";
import AlertBox from "../../component/AlertBox";
import DialogBox from "../../component/DialogBox";
import { FiAlertCircle } from "react-icons/fi";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { WordLimitIndicator } from "../../utils/WordLimitIndicator";
import { useSelector } from "react-redux";
import SwitchCompo from "../../component/SwitchCompo";
import { IoSearch } from "react-icons/io5";
import EmployeeSearch from "../../component/EmployeeSearch";
import SelectField from "../../component/SelectField";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

function Config({ setReload, termsAndCond, actionButton }) {
  const [letterTermsAndCond, setLetterTermsAndCond] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [selectedDesc, setSelectedDesc] = useState("");

  // set default value
  useEffect(() => {
    setLetterTermsAndCond(termsAndCond);
  }, [termsAndCond]);

  //add policy
  async function addPolicy() {
    if (selectedTitle?.length === 0 || selectedDesc?.length === 0) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please fill all the fields");
      return null;
    }
    const data = {
      title: selectedTitle,
      description: selectedDesc,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/letter/policy/add`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Policy added successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Policy added failed");
      console.log(error);
    } finally {
      setSelectedDesc("");
      setSelectedTitle("");
      setLoading(false);
    }
  }

  //edit policy
  async function editPolicy(policyId) {
    const data = {
      title: selectedTitle,
      description: selectedDesc,
      policyId: policyId,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/letter/policy/edit`,
        method: "put",
        withCredentials: true,
        data: data,
      });
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Policy edited successfully");
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Policy edit failed");
      console.log(error);
    } finally {
      setLoading(false);
      setSelectedDesc("");
      setSelectedTitle("");
    }
  }

  //delete policy
  async function deletePolicy(policyId) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/letter/policy/delete`,
        method: "delete",
        withCredentials: true,
        data: {
          policyId: policyId,
        },
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Policy deleted successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Policy delete failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // set prev value
  function setValue(data) {
    setSelectedTitle(data?.title);
    setSelectedDesc(data?.body);
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px] !z-[100000000]" />
      )}
      {success && (
        <AlertBox
          open={open}
          setOpen={setOpen}
          success={success}
          title={message}
        />
      )}
      {!success && (
        <AlertBox
          open={open}
          setOpen={setOpen}
          success={success}
          title={message}
        />
      )}
      <RightDrawer actionButton={actionButton} width="40">
        <div>
          <div className="w-full p-5" onClick={(eve) => eve.stopPropagation()}>
            <h2 className="font-semibold text-center text-[18px]">
              Terms & Conditions Configurations
            </h2>
            <div className="mt-5">
              {letterTermsAndCond?.length > 0 ? (
                <div>
                  <div className="flex justify-end">
                    <DialogBox
                      trigger={<ButtonCompo>Add T&C</ButtonCompo>}
                      title="New T&C"
                      actionButton={
                        <ButtonCompo onClick={addPolicy}>Save</ButtonCompo>
                      }
                    >
                      <div className="space-y-3">
                        <InputField
                          label="Title"
                          value={selectedTitle}
                          onChange={(eve) =>
                            setSelectedTitle(eve?.target?.value)
                          }
                          required
                        />
                        <InputField
                          label="Description"
                          value={selectedDesc}
                          onChange={(eve) =>
                            setSelectedDesc(eve?.target?.value)
                          }
                          required
                          multiline
                        />
                      </div>
                    </DialogBox>
                  </div>
                  {letterTermsAndCond?.map((tcData, i) => (
                    <section>
                      <section className="mt-3">
                        <section>
                          <p className="text-slate-500">
                            <span className="text-slate-700 font-semibold">
                              {tcData?.title}
                            </span>{" "}
                            {tcData?.body}
                          </p>
                          <p className="text-[15px] mt-[2px] text-slate-700">
                            Created at{" "}
                            {new Date(tcData?.createdAt).toLocaleDateString()}
                          </p>
                        </section>
                        <section className="mt-3 flex items-center gap-3 justify-end">
                          <DialogBox
                            trigger={
                              <ButtonCompo onClick={() => setValue(tcData)}>
                                Edit
                              </ButtonCompo>
                            }
                            title="Edit T&C"
                            actionButton={
                              <ButtonCompo
                                onClick={() => editPolicy(tcData?.polId)}
                              >
                                Save
                              </ButtonCompo>
                            }
                          >
                            <div className="space-y-3">
                              <InputField
                                label="Title"
                                value={selectedTitle}
                                onChange={(eve) =>
                                  setSelectedTitle(eve?.target?.value)
                                }
                                required
                              />
                              <InputField
                                label="Description"
                                value={selectedDesc}
                                onChange={(eve) =>
                                  setSelectedDesc(eve?.target?.value)
                                }
                                required
                                multiline
                              />
                            </div>
                          </DialogBox>
                          <ButtonCompo
                            color={"error"}
                            onClick={() => deletePolicy(tcData?.polId)}
                          >
                            Delete
                          </ButtonCompo>
                        </section>
                      </section>
                    </section>
                  ))}
                </div>
              ) : (
                <div>
                  <p className="text-center text-slate-500 font-medium">
                    No terms and conditions added yet
                  </p>
                  <section className="flex justify-center items-center">
                    <DialogBox
                      trigger={<ButtonCompo>Add T&C</ButtonCompo>}
                      title="New T&C"
                      actionButton={
                        <ButtonCompo onClick={addPolicy}>Save</ButtonCompo>
                      }
                    >
                      <div className="space-y-3">
                        <InputField
                          label="Title"
                          value={selectedTitle}
                          onChange={(eve) =>
                            setSelectedTitle(eve?.target?.value)
                          }
                          required
                        />
                        <InputField
                          label="Description"
                          value={selectedDesc}
                          onChange={(eve) =>
                            setSelectedDesc(eve?.target?.value)
                          }
                          required
                          multiline
                        />
                      </div>
                    </DialogBox>
                  </section>
                </div>
              )}
            </div>
          </div>
        </div>
      </RightDrawer>
    </>
  );
}

function TextLetterGenerate() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.letterGenerate === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [letterTermsAndCond, setLetterTermsAndCond] = useState([]);
  const [editedTermsAndCond, setEditedTermsAndCond] = useState([]);
  const [selectedYS, setSelectedYS] = useState("");
  const [selectedDesig, setSelectedDesig] = useState("");
  const [pdfLink, setPdfLink] = useState("");
  const [letterContent, setLetterContent] = useState("");
  const [letterHeading, setLetterHeading] = useState("");
  const [selectedTAndC, setSelectedTAndC] = useState([]);
  const [enableEmployeeDetailsButton, setEnableEmployeeDetailsButton] =
    useState(false);
  const [employeeId, setEmployeeId] = useState("");
  const [employeeFileUpload, setEmployeeFileUpload] = useState(false);
  const [expiredAt, setExpiredAt] = useState(undefined);
  const [shortDescription, setShortDescription] = useState("");
  const [allTemplates, setAllTemplates] = useState([]);
  // flag for word limit
  const [letterHeadingFlag, setLetterHeadingFlag] = useState(true);
  const [letterContentFlag, setLetterContentFlag] = useState(true);
  // params
  const { letterName } = useParams();

  async function getCompanyData() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/company/data`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setLetterTermsAndCond(res.data?.data?.letterPolicis || []);
      // direct offer letter edit
      setEditedTermsAndCond(res.data?.data?.letterPolicis || []);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Data fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // generate offer letter
  async function generateLetter() {
    if (
      letterContent?.length === 0 ||
      selectedYS?.length === 0 ||
      selectedDesig?.length === 0
    ) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please complete the STEP 1");
      return null;
    }
    if (enableEmployeeDetailsButton) {
      if (
        employeeId?.length === 0 ||
        shortDescription?.length === 0 ||
        expiredAt?.$d === undefined
      ) {
        setOpen(true);
        setSuccess(false);
        setMessage("Please complete the STEP 3");
        return null;
      }
    }
    const data = {
      template: letterContent,
      sender: selectedYS,
      designation: selectedDesig,
      termsAndCond: selectedTAndC,
      title: letterHeading,
      employeeId: employeeId,
      employeeUpload: employeeFileUpload,
      expiryDate:
        expiredAt?.$d !== undefined ? new Date(expiredAt?.$d) : undefined,
      description: shortDescription,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/generate/custom/text/letter`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      if (res.status >= 200 || res.status < 400) {
        setOpen(true);
        setSuccess(true);
        setMessage("Letter generated successfully");
        setPdfLink(res.data?.data);
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Letter generate failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // terms and condition array ops
  function handleChangeTAndCArray(status, data) {
    if (status) {
      setSelectedTAndC((prev) => [...prev, data]);
    } else {
      setSelectedTAndC((prev) => {
        const newArr = prev.filter((opt) => opt?.polId !== data?.polId);
        return newArr;
      });
    }
  }

  const employeeUploadOption = [
    {
      title: "Yes",
      value: true,
    },
    {
      title: "No",
      value: false,
    },
  ];

  // save file to employee account
  async function saveFileToEmployeeAccount() {
    if (pdfLink?.length === 0) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please generate the letter first");
      return null;
    }
    const data = {
      manualFilename: pdfLink,
      title: letterHeading,
      description: shortDescription,
      expiryDate:
        expiredAt?.$d !== undefined ? new Date(expiredAt?.$d) : undefined,
      employeeId: employeeId,
      employeeUpload: employeeFileUpload,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/hr/documents/add`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      if (res.status >= 200 || res.status < 400) {
        setOpen(true);
        setSuccess(true);
        setMessage("Letter saved successfully");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(
        error?.response?.data?.message || "Letter save failed to employee"
      );
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // fetch all templates
  async function getTemplates() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/letter/template/get/all/titles`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      const rawData = res.data?.data || [];
      let data = [];
      if (Array.isArray(rawData) && rawData.length > 0) {
        rawData.map((e, i) => {
          let obj = {
            title: e?.title,
            value: e?._id,
          };
          data.push(obj);
        });
      }
      setAllTemplates(data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Templates fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // fetch template
  async function getTemplate(templateId) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/letter/template/get/single/${templateId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      const rawData = res.data?.data
      setLetterContent(rawData?.template)
      setLetterHeading(rawData?.title)
      setSelectedYS(rawData?.sender)
      setSelectedDesig(rawData?.senderDesignation)
      // console.log(rawData?.termsArray)
      setLetterTermsAndCond(prev => {
        return [...prev, ...rawData?.termsArray]
      })
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("History fetch failed");
    } finally {
      setLoading(false);
    }
  }

  console.log(letterTermsAndCond)

  useEffect(() => {
    if (letterName === "Custom Letter") {
      setLetterHeading("");
    } else {
      setLetterHeading(letterName || "");
    }
  }, [letterName]);

  useEffect(() => {
    getCompanyData();
    getTemplates();
  }, [reload]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <section>
            <section className="flex justify-between items-center">
              <h1 className="text-[30px] font-medium text-left w-full">
                Generate {letterName}
              </h1>
              <section className="flex items-center gap-3">
                <SelectField
                  valueArray={allTemplates}
                  label="Select Template"
                  className="w-[11rem]"
                  setValue={eve => getTemplate(eve?.target?.value)}
                />
                <EmployeeSearch
                  trigger={
                    <section className="flex border items-center w-[10rem] gap-2 hover:shadow-md p-3 rounded-md cursor-pointer">
                      <IoSearch className="text-[17px] text-slate-700" />
                      <p className="text-slate-700 text-[14px]">
                        Search Employee
                      </p>
                    </section>
                  }
                />
                <Config
                  setReload={setReload}
                  termsAndCond={letterTermsAndCond}
                  actionButton={
                    <section className="flex border items-center gap-2 hover:shadow-md p-3 rounded-md cursor-pointer">
                      <IoSettingsOutline className="text-[17px] text-slate-700" />
                      <p className="text-slate-700 text-[14px]">
                        Configurations
                      </p>
                    </section>
                  }
                />
              </section>
            </section>
            {letterName === "Custom Letter" && (
              <section className="flex items-center gap-1 my-3">
                <FaCheckCircle size={20} className="text-green-500" />
                <p className="text-slate-700">
                  Generate any <span className="font-medium">text letter</span>{" "}
                  from here. E.g, Experience letter, Increament letter etc.
                </p>
              </section>
            )}
          </section>
          <div className="w-full mt-5">
            <div>
              <AccrodianBox
                title={
                  <p className="text-slate-800 font-medium">
                    <span className="bg-slate-200 text-slate-600 py-2 px-3 font-semibold rounded-full text-[15px]">
                      STEP 1
                    </span>{" "}
                    <span
                      className={
                        letterHeadingFlag === false ||
                        letterContentFlag === false
                          ? "text-red-600 font-medium"
                          : "text-slate-700 font-medium"
                      }
                    >
                      Template Settings
                    </span>
                  </p>
                }
                id={1}
                defaultExpanded
              >
                <div className="space-y-3">
                  <section>
                    {letterHeading.length > 0 && (
                      <section className="flex justify-end">
                        <WordLimitIndicator
                          limit={50}
                          words={letterHeading}
                          setFlag={setLetterHeadingFlag}
                        />
                      </section>
                    )}
                    <InputField
                      label="Title"
                      onChange={(eve) => setLetterHeading(eve?.target?.value)}
                      required
                      color={letterHeadingFlag === true ? "" : "error"}
                      value={letterHeading}
                    />
                  </section>
                  <section>
                    {letterContent.length > 0 && (
                      <section className="flex justify-end">
                        <WordLimitIndicator
                          limit={4000}
                          words={letterContent}
                          setFlag={setLetterContentFlag}
                        />
                      </section>
                    )}
                    <InputField
                      multiline
                      required
                      rows={20}
                      label="Template"
                      onChange={(eve) => setLetterContent(eve?.target?.value)}
                      color={letterContentFlag === true ? "" : "error"}
                      value={letterContent}
                    />
                  </section>
                  <section className="grid grid-cols-2 gap-5">
                    <InputField
                      label="Your Sincerely"
                      onChange={(eve) => setSelectedYS(eve?.target?.value)}
                      required
                      value={selectedYS}
                    />
                    <InputField
                      label="Designation"
                      onChange={(eve) => setSelectedDesig(eve?.target?.value)}
                      required
                      value={selectedDesig}
                    />
                  </section>
                </div>
              </AccrodianBox>
              <AccrodianBox
                title={
                  <p className="text-slate-800 font-medium">
                    <span className="bg-slate-200 text-slate-600 py-2 px-3 font-semibold rounded-full text-[15px]">
                      STEP 2
                    </span>{" "}
                    Terms & Conditions
                  </p>
                }
                id={3}
              >
                {editedTermsAndCond?.length > 0 ? (
                  <div>
                    <div className="flex justify-end">
                      <Config
                        setReload={setReload}
                        termsAndCond={letterTermsAndCond}
                        actionButton={<ButtonCompo>Add T&C</ButtonCompo>}
                      />
                    </div>
                    {letterTermsAndCond?.map((tcData, i) => (
                      <section key={i}>
                        <section className="mt-3">
                          <section className="text-slate-500 flex items-center">
                            <span className="text-slate-700 font-semibold">
                              <Checkbox
                                onChange={(event) =>
                                  handleChangeTAndCArray(
                                    event?.target?.checked,
                                    tcData
                                  )
                                }
                              />
                            </span>{" "}
                            <div>
                              <span className="text-slate-700 font-semibold">
                                {tcData?.title}
                              </span>{" "}
                              {tcData?.body}
                            </div>
                          </section>
                        </section>
                      </section>
                    ))}
                  </div>
                ) : (
                  <div className="flex flex-col justify-center items-center gap-5">
                    <p className="text-center text-slate-500 font-medium">
                      No terms and conditions added yet
                    </p>
                    <Config
                      setReload={setReload}
                      termsAndCond={letterTermsAndCond}
                      actionButton={
                        <section className="flex items-center gap-2 bg-slate-100 p-3 rounded-[10px] cursor-pointer hover:bg-slate-200/50">
                          <IoSettingsOutline className="text-[20px] text-slate-500" />
                          <p className="text-slate-700">Configurations</p>
                        </section>
                      }
                    />
                  </div>
                )}
              </AccrodianBox>
              <AccrodianBox
                title={
                  <p className="text-slate-800 font-medium">
                    <span className="bg-slate-200 text-slate-600 py-2 px-3 font-semibold rounded-full text-[15px]">
                      STEP 3
                    </span>{" "}
                    Generate Letter
                  </p>
                }
                id={4}
              >
                <div>
                  <p className="flex items-center gap-2">
                    <FiAlertCircle className="text-[20px]" /> Please check all
                    the steps before generating the letter.
                  </p>
                  <div className="flex justify-end mt-3 gap-3">
                    {pdfLink?.length > 0 && (
                      <div className="flex items-center gap-5">
                        <section className="flex items-center gap-3 w-[20rem]">
                          <p className="text-slate-700 font-medium">
                            Save letter to employee's account
                          </p>
                          <SwitchCompo
                            value={enableEmployeeDetailsButton}
                            setValue={(eve) =>
                              setEnableEmployeeDetailsButton(
                                eve?.target?.checked
                              )
                            }
                          />
                        </section>
                        <Link
                          to={`${SERVER_URL}/api/v1/file/view/${pdfLink}`}
                          target="_blank"
                        >
                          <ButtonCompo
                            variant={"contained"}
                            onClick={generateLetter}
                          >
                            Download Letter
                          </ButtonCompo>
                        </Link>
                      </div>
                    )}
                    {letterHeadingFlag === true &&
                    letterContentFlag === true ? (
                      <ButtonCompo
                        variant={"contained"}
                        onClick={generateLetter}
                      >
                        generate
                      </ButtonCompo>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </AccrodianBox>
            </div>
          </div>
          {enableEmployeeDetailsButton && (
            <div className="mt-10 border p-10 rounded-md shadow-lg">
              <div className="space-y-3">
                <div className="grid grid-cols-3 gap-5">
                  <InputField
                    label="Employee ID"
                    onChange={(eve) => setEmployeeId(eve?.target?.value)}
                  />
                  <SelectField
                    valueArray={employeeUploadOption}
                    label={"Employee File Upload"}
                    value={employeeFileUpload}
                    setValue={(eve) =>
                      setEmployeeFileUpload(eve?.target?.value)
                    }
                  />
                  <DatePicker
                    label="Expired At"
                    onChange={(val) => setExpiredAt(val)}
                  />
                </div>
                <InputField
                  label="Short Description"
                  onChange={(eve) => setShortDescription(eve?.target?.value)}
                />
                <section className="flex justify-end mt-5">
                  <ButtonCompo
                    onClick={saveFileToEmployeeAccount}
                    variant={"contained"}
                  >
                    Save to Employee Account
                  </ButtonCompo>
                </section>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default TextLetterGenerate;
